export default function NoSessionsIllustration() {
  return (
    <svg className="illustration" width="72" height="72" viewBox="0 0 72 72" fill="none">
      <rect x="12" y="20" width="48" height="34" rx="5" fill="var(--accent-bg)" stroke="var(--accent)" strokeWidth="1.5" />
      <path d="M12 28h48" stroke="var(--accent)" strokeWidth="1.5" />
      <circle cx="20" cy="24" r="1.6" fill="var(--accent)" />
      <circle cx="26" cy="24" r="1.6" fill="var(--accent)" />
      <rect x="20" y="34" width="24" height="3" rx="1.5" fill="var(--accent)" opacity="0.4" />
      <rect x="20" y="42" width="16" height="3" rx="1.5" fill="var(--accent)" opacity="0.25" />
    </svg>
  );
}
